import { Field } from 'formik'
import React from 'react'

import { Checkbox, Fieldset, Input } from '@fourthwall/components'

export const CheckboxForm = () => {
  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field name="label" component={Input} label="Label" placeholder="Setting label" />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name="info"
            component={Input}
            label="Info (optional)"
            placeholder="Help text for this setting"
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field name="default" component={Checkbox} label="Default Value" />
        </Fieldset.Item>
      </Fieldset.Row>
    </>
  )
}
